export function getExternalModel(value, modelValue) {
	if (value !== null && value !== undefined) return value;
	if (modelValue !== null && modelValue !== undefined) return modelValue;
	return null;
}

export function emitModel(ctx, payload) {
	ctx.$emit("input", payload);
	ctx.$emit("update:modelValue", payload);
}

export function constructAddress(place) {
	if (!place) return "";
	const line = [place.street_number ?? "", place.route ?? "", place.route2 ? `- ${place.route2}` : ""];
	return line.filter(Boolean).join(" ").trim();
}

export function constructLocation(place) {
	if (!place) return "";
	const line = [place.postal_code ?? "", place.locality ?? "", place.country ? `- ${place.country}` : ""];
	return line.filter(Boolean).join(" ").trim();
}

export function isEmptyPlace(establishment) {
	const p = establishment?.place;
	return establishment?.id === 0 || (!p?.locality?.length && !p?.postal_code && !p?.exported_address?.length);
}

export function flattenEstablishmentContacts(establishments = []) {
	const all = [];
	establishments.forEach((establishment, index) => {
		const name = establishment?.name?.length ? establishment.name : `établissement n°${index + 1}`;
		(establishment.contacts ?? []).forEach(contact => {
			all.push({
				...contact,
				establishment: {
					id: establishment.id,
					name
				}
			});
		});
	});
	return all;
}
